import echarts from "echarts";
import { tryOnUnmounted } from '@vueuse/core';
import { computed, nextTick, ref, unref } from "vue";
export function useECharts(elRef) {
    // echarts 实例
    let chartInstance = null;
    // 缓存配置
    const cacheOptions = ref({});
    const getOptions = computed(() => {
        return {
            backgroundColor: 'transparent',
            ...cacheOptions.value,
        };
    });
    // 初始化
    function initCharts() {
        const el = unref(elRef);
        if (!el || !unref(el)) {
            return;
        }
        chartInstance = echarts.init(el);
    }
    function removeResizeFn(){
        window.removeEventListener("resize", function () {
            chartInstance.resize();
        });
    }
    function setOptions(options) {
        cacheOptions.value = options;
        if (unref(elRef)?.offsetHeight === 0) {
            setTimeout(() => {
                setOptions(unref(getOptions));
             }, 30);
            return;
        }
        nextTick(() => {
            setTimeout(() => {
              if (!chartInstance) {
                initCharts();
                if (!chartInstance) return;
              }
              chartInstance?.setOption(unref(getOptions));
            }, 30);
          });

    }
    function getInstance(){
        if (!chartInstance) {
          initCharts();
        }
        return chartInstance;
      }
    tryOnUnmounted(() => {
        if (!chartInstance) return;
        removeResizeFn();
        chartInstance.dispose();
        chartInstance = null;
     });
    
    return {
        setOptions,
        getInstance
    };
}